import React, { useState } from "react";
import axios from "axios";
import SwitchLayer from "../SwitchLayer";
import OpacitySelector from "../OpacitySelector";
import { faMapPin, faPaintbrush, faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getRestrictedInfo } from "./RestrictedData";
import "../JSONToDivs.css";

const LayersCard = ({
  jsonFile,
  setLayerName,
  prevGroupName,
  fullPath,
  objectContent,
  setLayersThatWereSwitchedNames,
  setSwitchIsOn,
  setShowTooltip,
  setLayerOpacity,
  setBoundingBox,
  setButtonOn,
  checkedAll,
  setCheckedAll,
  layersThatWereSwitchedNames,
  activeLayers,
  setActiveLayers,
}) => {
  // console.log(jsonFile, "jsonFileStin Karta");
  // console.log(prevGroupName, "prevGroupName stin karta");
  // console.log(jsonFile, "jsonFileStin Karta");
  const [isActive, setIsActive] = useState(false);
  const [responseStatus, setResponseStatus] = useState(0);

  // Check user role from localStorage
  const userRole = localStorage.getItem("userRole");
  const isGuest = userRole === "guest" || !userRole;

  // Check restriction status using the imported helper
  const { isRestricted, attribution } = getRestrictedInfo(objectContent.Name, prevGroupName);

  // Determine if this specific card should be disabled/greyed out
  const isDisabled = isGuest && isRestricted;

  const hideOpacitySlider = (name) => {
    const ele = document.getElementById(
      `${name.replaceAll(" ", "-")}-opacity-slider`
    );
    if (ele) {
      if (ele.style.display === "block") {
        ele.style.display = "none";
      } else {
        ele.style.display = "block";
      }
    }
  };

  return (
    <div
      className="layer-card"
      id={`layer-card-${jsonFile.replaceAll(" ", "-")}`}
      title={isDisabled ? `Restricted Access: ${attribution}` : ""}
    >
      <div 
        className="layer-card-content"
        style={isDisabled ? { opacity: 0.5, pointerEvents: "none", filter: "grayscale(100%)" } : {}}
      >
        <div className="layer-switch-container" id={`${jsonFile}-layer-switch`}>
          <SwitchLayer
            name={objectContent.Name}
            setLayerName={setLayerName}
            setSwitchIsOn={setSwitchIsOn}
            bounds={objectContent.BoundingBox}
            setBoundingBox={setBoundingBox}
            checkedAll={checkedAll}
            setCheckedAll={setCheckedAll}
            setLayersThatWereSwitchedNames={setLayersThatWereSwitchedNames}
            nameThatWasSwitched={jsonFile}
            layersThatWereSwitchedNames={layersThatWereSwitchedNames}
            activeLayers={activeLayers}
            setActiveLayers={setActiveLayers}
          />
        </div>

        <div
          className="layer-title-container"
          style={{
            fontSize: prevGroupName.length > 20 ? "x-small" : "smaller",
          }}
        >
          {prevGroupName}
          {isDisabled && <span style={{ marginLeft: "5px", color: "#444" }}>(Restricted)</span>}
        </div>
        <div className="All-Styling-Buttons-Container">
          <div className="Zoom-container-button">
            <button
              className="styling-button"
              id={`${jsonFile}-zoom-button`}
              onClick={() => {
                setBoundingBox(objectContent.BoundingBox);
                setButtonOn(true);
              }}
              disabled={isDisabled}
            >
              {" "}
              {/* <FontAwesomeIcon icon={faMapPin} style={{ color: "#474747" }} /> */}
              <FontAwesomeIcon icon={isDisabled ? faLock : faMapPin} />
            </button>
          </div>
          <div className="Styling-container-button">
            <button
              className="styling-button"
              id={`${jsonFile}-layer-button`}
              onClick={() => {
                {
                  hideOpacitySlider(objectContent.Name);
                }
              }}
              disabled={isDisabled}
            >
              {" "}
              <FontAwesomeIcon
                icon={faPaintbrush}
                // style={{ color: "#474747" }}
              />
            </button>
            <div
              className="opacity-slider-container"
              id={`${objectContent.Name.replaceAll(" ", "-")}-opacity-slider`}
            >
              <OpacitySelector
                name={objectContent.Name}
                setLayerOpacity={setLayerOpacity}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayersCard;